import localStore from '../store';

export const STORE_KEY = '$_auth';

export default {
    created() {
        const globalStore = this.$store;

        if (globalStore && !globalStore.state[STORE_KEY]) {
            console.log('Attempting to register ', STORE_KEY);
            globalStore.registerModule(STORE_KEY, localStore);
            console.log(globalStore);
        }
    }
};
